export default __webpack_public_path__ + "static/media/center-introduce.c95b156e.jpg";